export default __webpack_public_path__ + "static/media/arrow_left_disabled.d128730c.svg";